import styled from "styled-components";

export const Link = styled.div`
  display: flex;
  max-width: max-content;
`;
export const MyButton = styled.button`
 text-decoration: none;
    color: white;
    background-color: #ffba00;
    border: #ffba00 solid medium;
    border-radius: 3em;
    margin: 1em 1em 1em 0;
    padding: 1.2em 1.5em 1.2em 1.5em;
    font-weight: bolder;
    text-transform: uppercase;
    box-shadow: 0 0 2em #ffba00;
    
    ${Link}:hover & {
    background-color: #c57a17;
    }
`;